export default {
  config: {
    method: "dishes/",
    title: "Блюда",
    objectName: "Блюдо",
    modifyCondition: () => false,
    import: {
      method: 'menu/import/'
    },
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "80px",
    },
    created_at: {
      default: "",
      type: "datetime",
      title: "Создан",
      preset: true,
    },
    updated_at: {
      default: "",
      type: "datetime",
      title: "Обновлен",
      preset: true,
    },
    name: {
      default: "",
      type: "text",
      title: "Название",
      width: "auto",
    },
    proteins: {
      default: "",
      type: "text",
      title: "Белки",
    },
    fats: {
      default: "",
      type: "text",
      title: "Жиры",
    },
    carbs: {
      default: "",
      type: "text",
      title: "Углеводы",
    },
    calories: {
      default: "",
      type: "text",
      title: "Калории",
    },
    weight: {
      default: "",
      type: "text",
      title: "Вес",
    },
  }
};
